import { lazy } from '@atlassian/react-loosely-lazy';
import type { SummaryInlineEdit as SummaryInlineEditType } from './main.tsx';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
export const AsyncSummaryInlineEdit = lazy<typeof SummaryInlineEditType>(() =>
	import(/* webpackChunkName: "async-summary-inline-edit" */ './main').then(
		({ SummaryInlineEdit }) => SummaryInlineEdit,
	),
);
